// extracted by mini-css-extract-plugin
export default {"ViewLabel":"labelField_ViewLabel__Gpagp","viewInput":"labelField_viewInput__k2kQC"};